module.exports = __webpack_public_path__ + "static/img/platform.d0aa2d3d.png";